import * as React from 'react';
import { shallow, mount } from 'enzyme';
import RevokeHandshakeModal, { Props } from './RevokeHandshakeModal';
import Modal from 'components/general/modal/modal';
import Button from 'lj_shared/button/button';

let props: Props;
let wrapped = null;

window.Routes = {
  job_ad: () => '',
  revoke_dashboard_handshake: () => '',
};

const createTestProps = () => {
  return {
    cancelReasons: [
      'I got a more interesting proposal.',
      "I got second feelings and I'm backing down",
    ],
    handshake: jest.fn(),
    handshake_company: {
      name: 'test company',
      id: 10032,
      logo: 'this is a logo URL',
    },
    handshake_job_ad: { title: 'my job', id: 177013 },
    setIsModalOpen: jest.fn(),
  };
};

describe('Revoke Handshake Modal component', () => {
  beforeAll(() => {
    props = createTestProps();
    wrapped = mount(<RevokeHandshakeModal {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });

  it('contains a Modal', () => {
    expect(wrapped.find(Modal).length).toEqual(1);
  });

  it('contains 2 Buttons', () => {
    expect(wrapped.find(Button).length).toEqual(2);
  });
});
